import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { DataViewModule } from 'primeng/dataview';
import { InputTextModule } from 'primeng/inputtext';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TabViewModule } from 'primeng/tabview';
import { AuthModule } from 'src/app/auth/auth.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { HighlightPipe } from '../../shared/pipes/highlight.pipe';
import { FulltextSearchComponent } from './components/fulltext-search.component';
import { FulltextviewerComponent } from './components/fulltextviewer/fulltext-viewer.component';
import { RicercaComponent } from './ricerca.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AuthModule,
    SharedModule,
    InputTextModule,
    CalendarModule,
    AutoCompleteModule,
    ButtonModule,
    SplitButtonModule,
    TabViewModule,
    DataViewModule,
    CheckboxModule
  ],
  exports: [
    RicercaComponent
  ],
  declarations: [
    RicercaComponent,
    FulltextSearchComponent,
    FulltextviewerComponent
  ],
  providers: [
    DatePipe,
    HighlightPipe
  ],
})
export class RicercaModule { }
